import React from 'react';
import { Button } from 'carbon-components-react';
import Form from 'react-jsonschema-form-carbon';
import { Add16, Delete16 } from '@carbon/icons-react';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

function FormCustom ({ formData, onSubmit }) {
  const schema = {
    type: 'object',
    required: [
      'name',
      'stages'
    ],
    properties: {
      name: {
        title: funcTranslateHelper('Builder:builder:form:state'),
        type: 'string'
      },
      stages: {
        type: 'array',
        title: funcTranslateHelper('Builder:builder:form:stages'),
        items: {
          title: funcTranslateHelper('Builder:builder:form:stages'),
          type: 'string'
        }
      }
    }
  };
  const Tpl = (props) => {
    const { id, label, required, children } = props;
    return (
      <div className='myfield'>
        <label htmlFor={id}>{label}{required ? '' : null}</label>
        <div className='input#root_name.bx--text-input'>
          {children}
        </div>
      </div>
    );
  };
  const ArrayFieldTemplate = (props) => {
    return (
      <div className={props.className + ' array-subform'}>
        <div className='subform-items'>
          {props.items &&
              props.items.map(element => {
                return (
                  <div
                    key={element.key}
                    className={
                      element.className + ' w-100 justify-content-between row m-0'
                    }
                    style={{ border: 'none' }}
                  >
                    {element.children}
                    <Button
                      className='bx--btn bx--btn--ghost bx--btn--sm remove-button'
                      onClick={element.onDropIndexClick(element.index)}
                    >
                      <Delete16 aria-label='Delete' />
                    </Button>
                  </div>
                );
              })}
        </div>

        {props.canAdd && (
          <div className='row'>
            <p className='col-xs-3 col-xs-offset-9 array-item-add text-right'>
              <Button
                className='bx--btn bx--btn--ghost bx--btn--sm add-item-button'
                onClick={props.onAddClick}
                renderIcon={Add16}
              >
                {funcTranslateHelper('Agregar')}
              </Button>
            </p>
          </div>
        )}
      </div>
    );
  };

  return (
    <Form
      id='formCustom'
      onSubmit={onSubmit}
      ArrayFieldTemplate={ArrayFieldTemplate}
      FieldTemplate={Tpl}
      formData={formData()}
      schema={schema}
    >
      <button style={{ display: 'none' }} />
    </Form>
  );
}

export default FormCustom;
